import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  caperTransactionsAccessControl,
  notOnFileRetailerAccessControl,
  inventoryIntelligenceAccessControl,
} from '../access-control/connectedStoresAccess.configuration'
import Toasts from '../toasts'

const ConnectedStoresCaperTransactionsPage = lazy(() => import('../pages/caper-transactions/page'))

// Not on File (Retailer)
const ConnectedStoresNotOnFileRetailerPage = lazy(() => import('../pages/not-on-file-retailer'))
const ConnectedStoresNotOnFileRetailerDetailsPage = lazy(
  () => import('../pages/not-on-file-retailer/details')
)

// Inventory Intelligence
const ConnectedStoresInventoryIntelligencePage = lazy(
  () => import('../pages/inventory-intelligence')
)

export const connectedStoresRetailerRouter = (
  <DomainRoute route="app-retailer-scope-connected-stores">
    <Toasts />
    <DashSwitch>
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-caper-transactions"
        component={ConnectedStoresCaperTransactionsPage}
        accessControl={caperTransactionsAccessControl}
      />
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-not-on-file"
        component={ConnectedStoresNotOnFileRetailerPage}
        accessControl={notOnFileRetailerAccessControl}
      />
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-not-on-file-details"
        component={ConnectedStoresNotOnFileRetailerDetailsPage}
        accessControl={notOnFileRetailerAccessControl}
      />
      <DomainRoute
        exact
        route="app-retailer-scope-connected-stores-inventory-intelligence"
        component={ConnectedStoresInventoryIntelligencePage}
        accessControl={inventoryIntelligenceAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
